<template>
  <ReuseableModal :modelValue="modelValue" @update:modelValue="$emit('update:modelValue', $event)" :title="(meeting.nextIncrementMeetingDetails && meetingType === 'increment') || (meeting.nextQuarterlyMeetingDetails && meetingType === 'quarterly') ? 'Edit Meeting' : 'Schedule Meeting'" :isLarge="true" submitButtonText="Save Meeting" closeButtonText="Cancel" :scrollable="true" :loading="loading.saveMeeting"
    @submit="saveMeeting" @close="resetForm">

    <div v-if="selectedEmployee" class="selected-employee">
      Employee: {{ selectedEmployee.username }}
    </div>

    <div class="meeting-form">

      <div class="row">
        <div class="field">
          <label>Date <span style="color: red; font-size: 14px;">*</span></label>
          <input type="date" v-model="form.date" />
          <small v-if="errors.date" class="error" style="margin-top: -4px;">{{ errors.date }}</small>
        </div>

        <div class="field">
          <label>Time <span style="color: red; font-size: 14px;">*</span></label>
          <input type="time" v-model="form.time" />
          <small v-if="errors.time" class="error" style="margin-top: 4px;">{{ errors.time }}</small>
        </div>
      </div>

      <!-- Title -->
      <div class="field field-container">
        <div>
          <label>Title <span style="color: red; font-size: 14px;">*</span></label>
          <input type="text" v-model="form.title" />
        </div>
        <small v-if="errors.title" class="error">{{ errors.title }}</small>
        <small v-else class="hint">Auto-generated, but you can edit it</small>
      </div>

      <div class="field">
        <label>Attendees <span style="color: red; font-size: 14px;">*</span></label>

        <div class="attendees-container">
          <label v-for="user in users" :key="user.id" class="attendee-item">
            <input type="checkbox" :value="user.email" v-model="form.attendees" class="attendees-checkbox" />
            <div style="display: flex; align-items: center; gap: 8px; width: max-content;">
              <template>
                <img style="width: 32px; height: 32px; border-radius: 20px; padding: 2px; border: 2px solid gray"
                  :src="user.profile_picture || 'static/img/default-dp.png'" alt="avatar">
              </template>
              <span>{{ user.username }}</span>
            </div>
          </label>
        </div>
        <small v-if="errors.attendees" class="error" style="margin-top: 4px;">{{ errors.attendees }}</small>
        <small v-else class="hint">
          {{ form.attendees.length }} attendee(s) selected
        </small>
      </div>

      <div class="field field-container">
        <div>
          <label>Description <span class="optional">(Optional)</span></label>
          <textarea v-model="form.description" placeholder="Optional"></textarea>
        </div>
        <small class="hint">Auto-generated, but you can edit or clear it</small>
      </div>

    </div>

    <template #footer>
      <button v-if="(meeting.nextIncrementMeetingDetails && meetingType === 'increment') || (meeting.nextQuarterlyMeetingDetails && meetingType === 'quarterly')" class="danger-button" :disabled="loading.deleteMeeting" @click="deleteMeeting">
        <span v-if="loading.deleteMeeting">
          <img src="/static/img/loader.gif" alt="Loading" style="width:18px; height:18px;vertical-align:middle; cursor: progress;" />
        </span>
        <span v-else>
          Delete Meeting
        </span>
      </button>

      <div style="display: flex; gap: 10px; margin-left: auto;">
        <button class="secondary-button" @click="$emit('update:modelValue', false)">
          Cancel
        </button>

        <button class="primary-button" style="width: 130px;" @click="saveMeeting" :disabled="loading.saveMeeting">
          <span v-if="loading.saveMeeting" style="width: 80px;">
            <img src="/static/img/loader.gif" alt="Loading" style="width:18px; height:18px;vertical-align:middle; cursor: progress;" />
          </span>
          <span v-else>
            Save Meeting
          </span>
        </button>
      </div>
    </template>
  </ReuseableModal>
</template>
<script>
import ReuseableModal from '../../components/UIComponents/ReuseableModal.vue';

export default {
  name: 'MeetingModal',
  components: { ReuseableModal },

  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    meeting: {
      type: Object,
      default: null
    },
    users: Array,
    meetingType: {
      type: String,
      default: 'quarterly',
      required: true
    },
    selectedEmployee: {
      type: Object,
      default: null
    },
    loading: {
      type: Object,
      default: () => ({
        saveMeeting: false,
        deleteMeeting: false
      })
    }
  },

  emits: ['update:modelValue', 'save', 'delete'],

  data() {
    return {
      form: {
        date: '',
        time: '',
        attendees: [],
        title: '',
        description: '',
        googleEventId: null
      },
      errors: {}
    }
  },
  computed: {
    selectedUsers() {
      return this.users.filter(user =>
        this.form.attendees.includes(user.email)
      )
    }
  },

  mounted() {
    if (this.meeting) {
      const dt = new Date(this.meeting.dateTime)

      this.form.date = dt.toISOString().slice(0, 10)
      this.form.time = dt.toTimeString().slice(0, 5)
      this.form.attendees = [...(this.meeting.attendees || [])]
      this.form.title = this.meeting.title || ''
      this.form.description = this.meeting.description || ''
      this.form.googleEventId = this.meeting.googleEventId || null
    } else {
      this.form.title = 'Quarterly / Increment Review Meeting'
    }
  },

  methods: {
    setFormFromMeeting() {
      if (!this.meeting) return
      
      let details = null
      
      if (this.meetingType === 'increment' && this.meeting.nextIncrementMeetingDetails) {
        details = this.meeting.nextIncrementMeetingDetails
      } else if (this.meetingType === 'quarterly' && this.meeting.nextQuarterlyMeetingDetails) {
        details = this.meeting.nextQuarterlyMeetingDetails
      } else if (this.meetingType === 'increment') {
        this.form.date = this.meeting.nextIncrementReview
      } else {
        this.form.date = this.meeting.nextQuarterlyMeeting
      }

      if (!details) return

      this.form.date = details.date || ''
      this.form.time = details.time || ''
      this.form.title = details.title || ''
      this.form.attendees = [...(details.attendees || [])]
      this.form.description = details.description || ''
      this.form.googleEventId = details.googleEventId || null
    },
    validateForm() {
      this.errors = {}

      if (!this.form.date) {
        this.errors.date = 'Date is required'
      }

      if (!this.form.time) {
        this.errors.time = 'Time is required'
      }

      if (!this.form.title) {
        this.errors.title = 'Title is required'
      }

      if (!this.form.attendees.length) {
        this.errors.attendees = 'At least one attendee is required'
      }

      return Object.keys(this.errors).length === 0
    },
    generateTitleAndDescription() {
      if (!this.selectedEmployee) return

      const name = this.selectedEmployee.username

      if (this.meetingType === 'quarterly') {
        this.form.title = `Quarterly Review Meeting - ${name}`
        this.form.description = `Scheduled quarterly review meeting for ${name} to discuss performance, goals, and development.`
      }

      if (this.meetingType === 'increment') {
        this.form.title = `Increment Review Meeting - ${name}`
        this.form.description = `Scheduled increment review meeting for ${name} to discuss performance, compensation changes, and next steps.`
      }
    },
    saveMeeting() {
      if (!this.validateForm()) return

      this.$emit('save', {
        date: this.form.date,
        time: this.form.time,
        attendees: this.form.attendees,
        title: this.form.title,
        description: this.form.description,
        ...(this.form.googleEventId && { googleEventId: this.form.googleEventId })
      })
    },

    deleteMeeting() {
      this.$emit('delete', this.meeting.id)
    },
    resetForm() {
      this.form = {
        date: '',
        time: '',
        attendees: [],
        title: '',
        description: '',
        googleEventId: null
      }
      this.errors = {}
    }
  },
  watch: {
    'form.date'() {
      delete this.errors.date
    },
    'form.time'() {
      delete this.errors.time
    },
    'form.title'() {
      delete this.errors.title
    },
    'form.attendees'() {
      delete this.errors.attendees
    },
    modelValue(isOpen) {
      if (!isOpen) {
        this.resetForm()
        return
      }

      this.generateTitleAndDescription()

      if (this.selectedEmployee.email) {
        this.form.attendees = [this.selectedEmployee.email]
      }

      if (this.meeting) {
        this.setFormFromMeeting()
      }
    },
    meetingType() {
      if (!this.meeting.nextQuarterlyMeetingDetails || !this.meeting.nextIncrementMeetingDetails && this.modelValue) {
        this.generateTitleAndDescription()
      }
    }
  }

}
</script>

<style scoped>
.meeting-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.row {
  display: flex;
  gap: 12px;
  padding-inline: 15px;
}

.field {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.field label {
  font-weight: 500;
  margin-bottom: 4px;
}

.field-container small {
  margin-top: -4px;
  font-size: 12px;
  color: #6b7280;
}

input,
textarea {
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-size: 14px;
}

textarea {
  resize: vertical;
  min-height: 90px;
}

.attendees-container {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px;
  max-height: 160px;
  overflow-y: auto;
}

.attendee-item {
  display: flex !important;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.hint {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.optional {
  font-size: 12px;
  color: #9ca3af;
  font-weight: normal;
}

.danger-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  width: 143px;
  min-width: 80px;
  transition: background-color 0.5s, color 0.3s;
  border: 1px solid #ef4444;
}

.attendees-checkbox {
  width: min-content !important;
  height: min-content;
  margin-top: 8px;
}

.selected-users {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.selected-employee {
  background: #f1f6fe;
  border: 1px solid #d6e4fa;
  color: #2b4089;
  padding: 12px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
  width: 100%;
}

.error {
  font-size: 12px !important;
  color: #dc2626 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/GoogleCalender/MeetingModal.vue